import VerifiedIcon from '@mui/icons-material/Verified';
import {
  Alert,
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useState } from 'react';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const BusinessStateArkansas = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Arkansas Business Tax filing requirements | TaxZerone"
          description="Learn about Arkansas business tax filing requirements with TaxZerone. Get step-by-step guidance to meet deadlines, file accurately, and stay compliant with Arkansas tax laws."
          keywords=" "
          canonical="business-tax/state-filing/arkansas-tax-filing-requirements/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <BusinessTaxSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/arkansas-business-tax-img.webp" />
                <source srcSet="/assets/images/arkansas-business-tax-img.png" />
                <img
                  src="/assets/images/arkansas-business-tax-img.png"
                  alt="Arkansas Business Tax Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">Arkansas</span>
                </span>{' '}
                Business Tax Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Understand Arkansas business taxes and simplify your filing
                process. Learn which forms to file, important deadlines,
                extensions, tax rates, and penalties to keep your business on
                track.
              </Typography>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/arkansas-business-tax-img-sm.webp" />
                <source srcSet="/assets/images/arkansas-business-tax-img-sm.png" />
                <img
                  src="/assets/images/arkansas-business-tax-img-sm.png"
                  alt="Arkansas Business Tax Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            What are the Business Tax Forms in Arkansas?
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
            The tax forms you need to file in Arkansas depend on your business
            structure. Here’s a breakdown:
          </Typography>

          <Grid container spacing={2} sx={{ mb: 5, justifyContent: 'center' }}>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/single-member-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/single-member-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/single-member-icon.png"
                    alt="Sole Proprietorship & Single-Member LLC "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sole Proprietorship & <br />
                    Single-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/2022_AR1000F_FullYearResidentIndividualIncomeTaxReturn.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1000F
                        </Link>{' '}
                        –
                      </span>{' '}
                      Arkansas Individual Income Tax Return{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.irs.gov/pub/irs-prior/f1040sc--2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Schedule C
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Profit or Loss from Business (attached to AR1000){' '}
                    </li>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/2024_Final_AR1000ES.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Form AR1000ES
                        </Link>{' '}
                        -
                      </span>{' '}
                      Estimated tax for Individuals
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/Partnership-income-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/Partnership-income-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/Partnership-income-icon.png"
                    alt="Partnership & Multi-Member LLC"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Partnership & Multi-Member LLC
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR1050_Partnership_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1050
                        </Link>{' '}
                        –
                      </span>{' '}
                      Partnership Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR_K-1_SubS_2021.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Schedule K-1 (Form AR 1050)
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Partner’s Share of Income, Deductions, Credits, etc.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/c-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/c-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/c-corporation-icon.png"
                    alt="C Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    C Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR1100CT_CorporationIncomeTaxReturn_2024.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1100CT
                        </Link>{' '}
                        –
                      </span>
                      Arkansas Corporation Income Tax Return
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR1100REC_ReconciliationSchedule_2023.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1100REC
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Net Operating Loss Carryover Worksheet
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR1100ESCT_CorporationEstimatedTaxVouchers_2025.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1100ESCT
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Corporation Estimated Tax Payment Voucher
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/s-corporation-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/s-corporation-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/s-corporation-icon.png"
                    alt="S Corporation"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.revenue.alabama.gov/wp-content/uploads/2023/01/22f20s.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1100S
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      S Corporation Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/withholding-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/withholding-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/withholding-tax-icon.png"
                    alt="Employer & Withholding Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Employer & Withholding Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/2024_AR941PT_FI.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR941PT
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Employer’s Quarterly Withholding Report
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/ARW_3.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form ARW3
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Annual Reconciliation of Income Tax Withheld
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="/information-returns/efile-irs-form-w2/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form W2
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Wage and Tax Statement
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/sale-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/sale-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/sale-tax-icon.png"
                    alt="Sales & Use Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Sales & Use Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.arkansas.gov/tss/procurement/bids/get_document.php/popup?doc_id=14965&doc_type=PDF"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form ET-1
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Excise Tax Report
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/PromoterApplication.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form ST-370
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Direct Pay Permit Application
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/business-tax-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/business-tax-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/business-tax-icon.png"
                    alt="Additional Arkansas Business Tax Forms"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Additional Arkansas Business Tax Forms
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/AR2220_CT_2021.pdf"
                          sx={{ color: '#0202ff' }}
                          target="_blank"
                        >
                          {' '}
                          Form AR2220
                        </Link>{' '}
                        –
                      </span>{' '}
                      Underpayment of Estimated Tax by Corporations
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://www.dfa.arkansas.gov/wp-content/uploads/2024_AR1000NR_PartYear_or_Non-ResidentIndividualIncomeTaxReturn.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form AR1000NR
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Nonresident and Part-Year Resident Income Tax Return
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                px: { md: 1, sm: 0, xs: 0 },
                textAlign: 'left',
                alignItems: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  // mx: 'auto',
                  p: 3,
                  py: 4,
                  borderRadius: 8,
                  minHeight: '100%',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/unemployment-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/unemployment-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/unemployment-icon.png"
                    alt="Unemployment Insurance Tax "
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>

                <Box sx={{ p: 0 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                  >
                    Unemployment Insurance Tax
                  </Typography>
                  <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        <Link
                          href="https://dws.arkansas.gov/wp-content/uploads/DWS-ARK-209B-Interactive-1.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form DWS-ARK-209B
                        </Link>{' '}
                        –{' '}
                      </span>{' '}
                      Employer’s Quarterly Contribution and Wage Report
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column' }}
          sx={{ pt: 2, pb: 2, justifyContent: 'center', mb: 5 }}
        >
          <Grid
            size={12}
            sx={{
              textAlign: { md: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'center', sm: 'center' },
                }}
              >
                What are the Deadlines for the Business Tax Forms in Arkansas?
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: { lg: 18, md: 16, sm: 14, xs: 14 }, mb: 3 }}
              >
                Timely filing is critical to avoid penalties. Here are the
                standard deadlines:
              </Typography>
            </Box>
          </Grid>
          <Grid size={12} justifyContent="center">
            <Box
              component="div"
              sx={{
                mb: 2,
                maxWidth: 800,
                justifyContent: 'center',
                alignItems: 'center',
                m: 'auto',
              }}
            >
              <TableContainer
                sx={{ border: '1px solid #828282', borderRadius: 2 }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        C Corporation
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'center',
                          backgroundColor: '#fff',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15th day of 4th month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15th day of 4th month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        S Corporation
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: '1px solid #828282',
                          textAlign: 'center',
                          backgroundColor: '#fff',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15th day of 3rd month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        15th day of 3rd month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Partnerships / Multi-Member LLCs
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15th day of 3rd month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Sole Proprietorships
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        April 15 (same as individual income tax deadline)
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Limited Liability Companies
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        15th day of the 4th month
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        rowSpan={2}
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Franchise Tax / Annual Report
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        May 1 of each year
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Payment due date:
                        </span>{' '}
                        May 1 of each year
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Employer Withholding Tax
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Monthly return (AR941M):
                            </span>{' '}
                            Due by the 15th day of the following month{' '}
                          </li>
                          <li>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Annual reconciliation (ARW-3):
                            </span>{' '}
                            Due by January 31{' '}
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        Sales and Use Tax
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                          borderBottom: '1px solid #828282',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        <ul>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Monthly filers:
                            </span>{' '}
                            Due by the 20th day of the following month
                          </li>
                          <li style={{ marginBottom: 8 }}>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Quarterly filers:
                            </span>{' '}
                            Due by the 20th day of the month after the quarter
                            ends
                          </li>
                          <li>
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              Annual filers:
                            </span>{' '}
                            Due by January 20
                          </li>
                        </ul>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          borderRight: '1px solid #828282',
                          backgroundColor: '#fff',
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        Unemployment Insurance Tax
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'left',
                          backgroundColor: '#fff',
                        }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 600 }}>
                          Return due date:
                        </span>{' '}
                        Due by the last day of the month following the quarter
                        end (April 30, July 31, October 31, January 31)
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Alert
              severity="info"
              id="who"
              icon={false}
              sx={{
                mt: 3,
                mb: 1,
                borderLeft: '3px solid #0288d1',
                textAlign: 'left',
                maxWidth: 800,
                mx: 'auto',
              }}
            >
              <span style={{ fontWeight: 600 }}> Important Reminder:</span> An
              extension gives you extra time to{' '}
              <span style={{ fontWeight: 600 }}>file,</span> not to{' '}
              <span style={{ fontWeight: 600 }}>pay.</span> All taxes owed must
              be paid by the original due date to avoid penalties and interest.
            </Alert>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Business Extension Forms are required in Arkansas?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 0, fontSize: 20, fontWeight: 600 }}
                >
                  Business Type
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    mb: 3,
                    mr: 2,
                    listStyleType: 'none',
                    '& li': { mb: 1.5 },
                  }}
                >
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      C Corporations & S corporation
                    </Box>
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Partnerships & LLCs taxed as Partnerships
                    </Box>{' '}
                  </li>
                  <li>
                    <Box>
                      {' '}
                      <VerifiedIcon
                        sx={{ mb: -0.6, mr: 1, color: '#6436b7' }}
                      />
                      Pass- Through Entities (PTE)
                    </Box>{' '}
                  </li>
                </Box>
                <Typography variant="body1">
                  Pass- Through Entities (PTE) Form AR1155-PET Business tax
                  payments can also be made online through the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Arkansas Taxpayer Access Point (ATAP)
                  </span>{' '}
                  at:
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mt: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note:</b> TaxZerone supports{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    filing Form 7004
                  </Link>{' '}
                  for{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    federal business tax extensions
                  </span>{' '}
                  and provides step-by-step guidance for Arkansas state
                  extension forms (
                  <span style={{ fontWeight: 600 }}>
                    AR1155, AR1055-PE, and AR1155-PET
                  </span>
                  ).
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6 }}>
              {/* <Link href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"> */}
              <Box
              // sx={{
              //   '&:hover': {
              //     transform: 'scale(1.02)',
              //   },
              //   '& .img-responsive:hover': {
              //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              //   },
              //   transition: 'transform 0.3s ease-in-out',
              // }}
              >
                <picture>
                  <source srcSet="/assets/images/arkansas-extension-img.webp" />
                  <source srcSet="/assets/images/arkansas-extension-img.png" />
                  <img
                    src="/assets/images/arkansas-extension-img.png"
                    alt="What Business Extension Forms are required in Arkansas?"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                    style={{ borderRadius: 24 }}
                  />
                </picture>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What are the Extended due dates for Business Tax
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                Forms in Arkansas?
              </Typography>
              <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 22, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      C Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> day
                      </Box>
                      <br />
                      of 10th month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      S Corporations
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> day
                      </Box>
                      <br />
                      of 9th month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Partnerships / Multi-Member LLCs
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        15<sup>th</sup> day
                      </Box>
                      <br />
                      of 9th month
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Sole Proprietorships
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      <Box
                        component="span"
                        sx={{
                          fontSize: { lg: 36, md: 34, sm: 28, xs: 20 },
                          fontWeight: 700,
                          color: '#42247b',
                        }}
                      >
                        {' '}
                        October 15
                      </Box>
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Employer Withholding Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ mb: 0, textAlign: 'left', '& li': { mb: 1.2 } }}
                    >
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          If taxed as corporation –
                        </span>{' '}
                        15th day of the 10th month
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          If taxed as partnership –
                        </span>{' '}
                        15th day of the 9th month
                      </li>
                    </Box>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Franchise Tax / Annual Report
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No extension allowed
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Employer Withholding Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No extension permitted
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  justifyContent="center"
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Sales and Use Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No extension permitted
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      width: '100%',
                      backgroundColor: '#f0f2f9',
                      justifyContent: 'center',
                      alignContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      }}
                    >
                      Unemployment Insurance Tax
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Extended due date:
                    </Typography>
                    <Typography variant="body1">
                      No extension permitted
                    </Typography>
                  </Paper>
                </Stack>
              </Box>
            </Grid>
            <Grid size={12} className="responsive" textAlign="center" mb={3}>
              <Typography variant="body1">
                Taxes owed must still be paid by the{' '}
                <span style={{ fontWeight: 600 }}> original due date</span> to
                avoid penalties and interest
              </Typography>
              <Alert
                severity="warning"
                icon={false}
                sx={{
                  mt: 4,
                  textAlign: 'left',
                  borderLeft: '3px solid rgb(102, 60, 0)',
                }}
              >
                <b>Note:</b> Arkansas allows a{' '}
                <span style={{ fontWeight: 600 }}>
                  6-month extension to file
                </span>{' '}
                for most business entities if a valid{' '}
                <span style={{ fontWeight: 600 }}>
                  Form AR1155, AR1055-PE, or AR1155-PET
                </span>{' '}
                is filed <span style={{ fontWeight: 600 }}>on or before</span>{' '}
                the original due date — or if a valid{' '}
                <span style={{ fontWeight: 600 }}>
                  federal extension (Form 7004)
                </span>{' '}
                has been granted.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          mb: 5,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container
          maxWidth="xl"
          sx={{
            mb: 5,
            '& .card__content': {
              animation: 'scale linear forwards',
              animationTimeline: 'view()',
              animationRange: '85vh 100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 680, xs: 695 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(210, 186, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  textAlign: 'left',
                  alignItems: 'left',

                  justifyContent: 'left',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Arkansas Business Tax Extension Filing Requirements
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  To qualify for a business tax extension in Arkansas, your
                  business must:
                </Typography>
                <Box sx={{ maxWidth: 'auto', textAlign: 'left' }}>
                  <Box
                    component="ul"
                    sx={{
                      mb: 0,
                      mr: 2,
                      listStyleType: 'none',
                      '& li': { mb: 2, fontSize: { md: 17, sm: 16, xs: 14 } },
                    }}
                  >
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          File by the original due date
                        </span>{' '}
                        to avoid penalties and interest—extensions apply only to
                        filing, not payments.
                      </Box>
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Submit the correct Arkansas extension form
                        </span>{' '}
                        based on your entity type (Form{' '}
                        <span style={{ fontWeight: 600 }}>AR1155</span> for
                        corporations or Form{' '}
                        <span style={{ fontWeight: 600 }}>AR1055-PE</span> for
                        partnerships and multi-member LLCs).
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Estimate and pay any taxes owed
                        </span>{' '}
                        by the original return due date, even if you file for an
                        extension.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Attach a copy of your federal extension (Form 7004)
                        </span>{' '}
                        if applicable—Arkansas automatically honors a valid
                        federal extension.
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Meet the 6-month extension window,
                        </span>{' '}
                        typically extending your filing deadline but not your
                        payment deadline.{' '}
                      </Box>{' '}
                    </li>
                    <li>
                      <Box>
                        {' '}
                        <VerifiedIcon
                          sx={{
                            mb: -0.8,
                            mr: 1,
                            color: '#6436b7',
                            fontSize: 28,
                          }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Keep proof of filing and payment confirmations
                        </span>{' '}
                        from the Arkansas Department of Finance and
                        Administration (DFA) for compliance.
                      </Box>{' '}
                    </li>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Box sx={{}}>
                  <picture>
                    <source
                      srcSet="/assets/images/arkansas-state-img.webp"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <source
                      srcSet="/assets/images/arkansas-state-img.png"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                    <img
                      src="/assets/images/arkansas-state-img.png"
                      loading="lazy"
                      alt="business tax extension in Arkansas"
                      className="mw-100"
                      width={550}
                      height={450}
                    />
                  </picture>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: { xs: 'inherit', lg: 'sticky' },
              mt: 8,
              mb: 0,
              top: { md: 80, lg: 120, xl: 125 },
              // minHeight: { md: '50vh', lg: '60vh', xl: '70vh' },
              minHeight: { md: 550, lg: 615, xs: 705 },
              borderRadius: 6,
              px: 5,
              py: 3,
              background:
                'radial-gradient(circle,rgba(255, 255, 255, 1) 55%, rgba(237, 232, 232, 1) 86%, rgba(244, 237, 255, 1) 100%)',
              border: '1px solid #ccc',
            }}
            className="card__content"
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: 'container' }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                <Box
                  component="div"
                  sx={{
                    mb: 3,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    Arkansas Business Tax Rates
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 400,
                      textAlign: 'center',
                    }}
                  >
                    Business tax rates vary depending on your entity type:
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    C Corporations
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, textAlign: 'left', '& li': { mb: 1.5 } }}
                  >
                    <li>
                      {' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        1.0%{' '}
                      </span>
                      on first $3,000 of net taxable income (NTI)
                    </li>
                    <li>
                      {' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        2.0%{' '}
                      </span>
                      on $3,001–$6,000
                    </li>
                    <li>
                      {' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        3.0%{' '}
                      </span>
                      on $6,001–$11,000
                    </li>
                    <li>
                      {' '}
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: 18,
                        }}
                      >
                        {' '}
                        Top rate:
                      </span>{' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        4.8%{' '}
                      </span>
                      on income over $11,000 (tax years beginning Jan 1, 2024)
                    </li>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    S Corporation
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 36, sm: 28, xs: 20 },
                      color: '#291972',
                    }}
                  >
                    Pass-Through
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    income taxed at owner level, not entity level in most cases
                  </Typography>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 3,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Pass – Through Entity
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, textAlign: 'left', '& li': { mb: 1.5 } }}
                  >
                    <li>
                      {' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        4.9%{' '}
                      </span>
                      on income (tax years beginning 2022)
                    </li>
                    <li>
                      {' '}
                      <span
                        style={{
                          color: '#291972',
                          fontWeight: 600,
                          fontSize: 26,
                        }}
                      >
                        {' '}
                        2.45%{' '}
                      </span>
                      on capital gains (tax years beginning 2022)
                    </li>
                  </Box>
                </Paper>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    minHeight: '100%',
                    textAlign: 'center',
                    backgroundColor: '#f0f2f9',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 21, sm: 18, xs: 16 },
                    }}
                  >
                    Sales & Use Tax
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 36, color: '#291972' }}
                  >
                    6.50%
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: 18 }}>
                    state base rate
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Estimated Tax Payments for Arkansas Businesses
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 3,
                    fontSize: { md: 19, sm: 18, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Businesses must make estimated tax payments if they expect to
                  owe <span style={{ fontWeight: 600 }}> $1,000 or more</span>
                  <br /> in state income tax for the year. This applies to:
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Payment Deadlines
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      1<sup>st</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      April 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      2<sup>nd</sup> payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      June 15
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      3<sup>rd</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Sept 15
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 500, fontSize: 18, mb: 1 }}
                    >
                      4<sup>th</sup> Payment
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 25, fontWeight: 700, color: '#42247b' }}
                    >
                      Dec 15
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 2,
                  backgroundColor: '#f0f2f9',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 3,
                    fontSize: { md: 21, sm: 18, xs: 16 },
                    textAlign: 'center',
                  }}
                >
                  Who should pay
                </Typography>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 2 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      C Corporations & S Corporations
                    </Typography>
                    <Typography variant="body1">
                      If expected tax &gt; $1,000
                    </Typography>
                  </Paper>

                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Partnerships & Sole Proprietors
                    </Typography>
                    <Typography variant="body1">
                      Pay using{' '}
                      <span style={{ fontWeight: 600 }}>Form AR1000ES</span>{' '}
                      (Estimated Income Tax Payment Voucher)
                    </Typography>
                  </Paper>
                </Stack>
                <Stack
                  spacing={2}
                  direction={{ xs: 'column', sm: 'row' }}
                  sx={{ mb: 0 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '  100%',
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18, mb: 1 }}
                    >
                      Limited Liability Companies (LLCs)
                    </Typography>
                    <Typography variant="body1">
                      Based on total income; if taxed as a corporation, use
                      corporate rates; if pass-through, payment is made at owner
                      level.
                    </Typography>
                  </Paper>
                </Stack>
              </Paper>
            </Grid>
            <Grid
              size={12}
              sx={{
                mt: 2,
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box
                component="div"
                sx={{
                  backgroundColor: '#f5efff',
                  borderLeft: '5px solid #45247e',
                  p: 2,
                  mb: 4,
                  borderRadius: 2,
                  textAlign: 'left',
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 14, mt: 0 }}>
                  <span style={{ fontWeight: 600 }}> Missed Payments:</span>{' '}
                  Late or missed estimated tax payments may result in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    interest and penalties
                  </span>{' '}
                  from the Arkansas DFA.
                  <br /> Payments can be made online through the
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Arkansas Taxpayer Access Point (ATAP)
                  </span>{' '}
                  system.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ pt: 2, mb: 5 }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mt: 0,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Penalties and Interest for Business in Arkansas
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { md: 18, sm: 16, xs: 16 },
                  textAlign: 'center',
                }}
              >
                If your business doesn’t pay the required tax by the original
                due date,
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>{' '}
                {'  '}
                penalties and interest may apply—even if you’ve filed an
                extension.
              </Typography>
              <Stack
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '42%',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '50%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Payment Penalty
                    </Typography>
                    <Typography variant="body1">
                      1% of the unpaid tax for each month (or part of a month)
                      the payment is late, up to a maximum of 35% of the tax
                      due.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                      minHeight: '42%',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Late Filing Penalty
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2 }}>
                      5% of the unpaid tax for each month (or part of a month)
                      the return is late, up to a maximum of 35% of the unpaid
                      amount.
                    </Typography>
                  </Paper>
                </Box>
                <Box
                  sx={{
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Interest
                    </Typography>
                    <Typography variant="body1">
                      Interest is charged on any unpaid tax balance at a rate of
                      10% per year, calculated from the original due date until
                      the tax is fully paid.
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 2,
                      backgroundColor: '#fff',
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: { md: 21, sm: 18, xs: 16 },
                      }}
                    >
                      Additional Penalties
                    </Typography>
                    <Box
                      component="ul"
                      sx={{ listStyleType: 'disc', mb: 0, '& > li': { mb: 1 } }}
                    >
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Negligence or disregard of tax rules:
                        </span>{' '}
                        10% of the tax deficiency.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Fraudulent underpayment:
                        </span>{' '}
                        50% of the tax deficiency.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Corporate Franchise Tax:
                        </span>{' '}
                        $25 penalty plus 10% annual interest on unpaid tax.
                      </li>
                    </Box>
                  </Paper>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/state-help-img.webp" />
                  <source srcSet="/assets/images/state-help-img.png" />
                  <img
                    src="/assets/images/state-help-img.png"
                    alt="How TaxZerone Can Help You?"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  How TaxZerone can Help You?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  TaxZerone supports{' '}
                  <span style={{ fontWeight: 600 }}>federal tax filing</span>{' '}
                  and also{' '}
                  <span style={{ fontWeight: 600 }}>
                    guides you through state-specific requirements
                  </span>{' '}
                  to help your business stay compliant. While Arkansas business
                  taxes must be filed directly with the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Department of Finance and Administration (DFA),
                  </span>{' '}
                  TaxZerone provides the guidance you need to:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    Understand which{' '}
                    <span style={{ fontWeight: 600 }}>
                      Arkansas business tax forms
                    </span>{' '}
                    apply to your entity type
                  </li>
                  <li>
                    Know your{' '}
                    <span style={{ fontWeight: 600 }}>
                      state deadlines and payment requirements
                    </span>{' '}
                  </li>
                  <li>
                    Prepare for{' '}
                    <span style={{ fontWeight: 600 }}>
                      extensions and estimated tax payments
                    </span>{' '}
                  </li>
                  <li>Avoid penalties by staying informed and organized </li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  With TaxZerone, you can manage your{' '}
                  <span style={{ fontWeight: 600 }}>
                    federal filings easily
                  </span>
                  while ensuring your{' '}
                  <span style={{ fontWeight: 600 }}>
                    Arkansas state obligations
                  </span>{' '}
                  are met on time and correctly.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Start Filing with Confidence Today!
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 500,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          File your federal returns easily with TaxZerone and get guided support
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>
          for your Arkansas business taxes — all in one place.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
          }}
        >
          Stay compliant, avoid penalties, and simplify your business tax filing
          process.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=arkansas`}
          >
            Start Filing Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 5 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Does Arkansas recognize an automatic federal extension
                  (Form 7004)?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Yes. If you file for a federal extension using{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 7004
                    </Link>
                    , Arkansas automatically grants the same filing extension.
                    However,{' '}
                    <span style={{ fontWeight: 600 }}>
                      any tax due must still be paid by the original due date
                    </span>{' '}
                    (April 15 for calendar filers) to avoid interest and
                    penalties.
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}> Interest rate:</span>{' '}
                        10% per year (calculated daily at 0.00027397)
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Penalty for late payment:
                        </span>{' '}
                        5% per month on unpaid tax
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do I need to attach my federal income tax return with the
                  Arkansas return?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1 }}>
                      Yes. Arkansas law requires you to attach a{' '}
                      <span style={{ fontWeight: 600 }}>
                        complete copy of your federal return
                      </span>{' '}
                      (Form 1120, 1120A, or 1120S) along with all schedules and
                      attachments. If any amounts differ between your federal
                      and Arkansas return, include a{' '}
                      <span style={{ fontWeight: 600 }}>
                        reconciliation schedule
                      </span>{' '}
                      explaining each difference.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What if my business has no income or is inactive?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 1.5 }}>
                      Even if your business had{' '}
                      <span style={{ fontWeight: 600 }}>no income</span> or was
                      inactive during the year, you must still{' '}
                      <span style={{ fontWeight: 600 }}>
                        file an Arkansas corporate income tax return
                      </span>{' '}
                      to maintain good standing.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What happens if I don’t file my business taxes in Arkansas?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      Failing to file can result in{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        penalties up to 35% of the unpaid tax, 10% annual
                        interest,
                      </span>{' '}
                      and possible{' '}
                      <span style={{ fontWeight: 600 }}>
                        loss of good standing
                      </span>{' '}
                      with the state, which can impact business licenses or
                      registrations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BusinessStateArkansas;
